import { initComparatorWithConversion } from 'src/sensors/list/InitComparatorWithConversion.ts';
import { Units } from 'uom-units';
import { NUMERIC_ATTRIBUTES } from 'src/modules/common/constants.ts';
import { GetComparator } from 'src/common/types/Comparator.ts';
import { initComparatorForRange } from 'src/sensors/list/InitComparatorForRange.ts';
import { initComparator } from 'src/modules/common/components/FilterContent/initComparator.ts';
import { LocalesEnum } from 'src/generated/operations.ts';
import { initComparatorFor281 } from 'src/sensors/list/initComparatorFor281.ts';

const ProbeLengthAttrId = '7984';
const RangeAttrs = [
    '8386',
    '8028',
    '8256',
];

export const createGetComparator = (locale: LocalesEnum): GetComparator => (attribute: string) => {
    if (attribute === '281') {
        return initComparatorFor281();
    }
    if (attribute === ProbeLengthAttrId) {
        return initComparatorWithConversion(Units.Millimeter);
    }
    if (RangeAttrs.includes(attribute)) {
        return initComparatorForRange();
    }
    return NUMERIC_ATTRIBUTES.includes(attribute)
        ? initComparator({
            sortAsNumeric: true,
            locale: locale.substring(0, 2),
            sortBy: 'value',
            sortOrder: 'asc',
        }) : initComparator({
            sortAsNumeric: false,
            locale: locale.substring(0, 2),
            sortBy: 'label',
            sortOrder: 'asc',
        });
};
